import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { Globe } from 'lucide-react';

// --- API BAĞLANTI AYARI ---
const BACKEND_URL = process.env.NODE_ENV === 'production' ? '' : 'http://localhost:8000';
const API = `${BACKEND_URL}/api`;

function Navbar() {
  const { t, language, toggleLanguage } = useLanguage();
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [siteTitle, setSiteTitle] = useState("MERTT");

  useEffect(() => {
    // 1. Scroll Olayı
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);

    // 2. Veritabanından Site Başlığını Çek
    // Backend URL düzeltmesi ile güvenli fetch
    const fetchUrl = process.env.REACT_APP_API_URL 
        ? `${process.env.REACT_APP_API_URL}/api/settings`
        : `${API}/settings`;

    fetch(fetchUrl)
      .then(res => res.json())
      .then(data => {
        if (data && data.about_title) {
            setSiteTitle(data.about_title);
        }
      })
      .catch(err => console.error("Navbar veri hatası:", err));

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path) => location.pathname === path;

  return (
    <nav
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${
        scrolled ? 'glass py-4' : 'bg-transparent py-6'
      }`}
    >
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="font-emblema text-3xl text-gradient" data-testid="logo">
            {siteTitle}
          </Link>

          <div className="hidden md:flex items-center space-x-8">
            {/* ANA SAYFA */}
            <Link
              to="/"
              data-testid="nav-home"
              className={`transition-colors ${
                isActive('/') ? 'text-cyan-400' : 'text-gray-300 hover:text-cyan-400'
              }`}
            >
              {t('nav.home')}
            </Link>

            {/* HİZMETLER (DÜZELTİLDİ: Artık ayrı sayfaya gidiyor) */}
            <Link
              to="/services"
              data-testid="nav-services"
              className={`transition-colors ${
                isActive('/services') ? 'text-cyan-400' : 'text-gray-300 hover:text-cyan-400'
              }`}
            >
              {t('nav.services')}
            </Link>

            {/* BLOG */}
            <Link
              to="/blog"
              data-testid="nav-blog"
              className={`transition-colors ${
                isActive('/blog') ? 'text-cyan-400' : 'text-gray-300 hover:text-cyan-400'
              }`}
            >
              {t('nav.blog')}
            </Link>
            
            {/* İLETİŞİM (DÜZELTİLDİ: App.js'deki /contact rotasına uyumlu) */}
            <Link
              to="/contact"
              data-testid="nav-contact"
              className={`transition-colors ${
                isActive('/contact') ? 'text-cyan-400' : 'text-gray-300 hover:text-cyan-400'
              }`}
            >
              {t('nav.contact')}
            </Link>
          </div>

          <div className="flex items-center space-x-4">
            <button
              onClick={toggleLanguage}
              data-testid="language-toggle"
              className="flex items-center space-x-2 px-4 py-2 rounded-full glass hover:border-cyan-400 transition-all"
            >
              <Globe size={18} />
              <span className="font-semibold">{language.toUpperCase()}</span>
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;